module.exports = __webpack_public_path__ + "img/20191223132643931.6139faa9.jpg";